<div class="wf-section">
  <div>
    <h1 class="heading-16"> </h1>
  </div>
</div>
<div id="QueEsEasyMed" *ngIf="sitio=='EasyMed'" data-w-id="fa9537cb-b68c-698a-bdc6-638c33a059db" class="section-foto-1-easymed wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6">
      <h1 class="heading"><br>EasyMed es acceso fácil y eficiente a la historia clínica de los pacientes<br>‍</h1>
      <p class="paragraph">Con EasyMed el médico puede revisar e ingresar información de sus pacientes en su consultorio, mientras pasa visita o incluso desde su casa. <br></p>
      <a href="#" class="button-copy w-button">Mire una demostración</a>
      <p class="paragraph"><br><br></p>
    </div>
    <div class="w-col w-col-6"></div>
  </div>
</div>
<div id="QueEsEfisys" *ngIf="sitio=='Efisys'" data-w-id="fa9537cb-b68c-698a-bdc6-638c33a059db" class="section-foto-1-efisys wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6">
      <h1 class="heading"><br>Efisys Facturación es la herramienta fácil y eficiente para generar facturas electrónicas<br>‍</h1>
      <p class="paragraph">Con Efisys Facturación Usted puede facturar, generar el archivo XML, obtener la autorización, generar el PDF y enviarlo por e-mail, cumpliendo la obligación dictada por el SRI. <br></p>
      <a href="#" class="button-copy w-button">Mire una demostración</a>
      <p class="paragraph"><br><br></p>
    </div>
    <div class="w-col w-col-6"></div>
  </div>
</div>
<div *ngIf="sitio=='EasyMed'" class="section-texto wf-section">
  <div class="columns-2 w-row">
    <div class="w-col w-col-6">
      <h2 class="heading2">La información que el médico necesita justo cuando la necesita‍</h2>
      <p class="paragraph">Es muy importante para el médico contar con datos exactos para tomar decisiones, no solo cuando está en su consultorio sino fuera de él: en la visita al paciente, cuando recibe una llamada de urgencia. EasyMed almacena toda la información siempre actualizada y permite consultarla o ingresar nuevos datos en cualquier momento y lugar.<br>‍</p>
    </div>
    <div class="w-col w-col-6">
      <h2 class="heading2">La tecnología más actualizada permite un acceso fácil y rápido a los datos</h2>
      <p class="paragraph">EasyMed almacena las historias clínicas en una base de datos en la nube, permitiendo que el médico y su equipo de apoyo la puedan consultar y modificar desde computadoras, celulares o tabletas por medio de un navegador web o una app para Android. La base de datos utiliza tecnología de Google  para lograr la máxima velocidad, estabilidad y seguridad.</p>
    </div>
  </div>
</div>
<div *ngIf="sitio=='Efisys'" class="section-texto wf-section">
  <div class="columns-2 w-row">
    <div class="w-col w-col-6">
      <h2 class="heading2">Un proceso sencillo para cumplir una obligación compleja</h2>
      <p class="paragraph">Aunque existen muchas maneras de cumplir con la facturación electrónica, Efisys lo hace todo más sencillo. Basta con llenar la factura y el proceso se realiza completamente solo.<br>‍</p>
      <p class="paragraph"><br></p>
    </div>
    <div class="w-col w-col-6">
      <h2 class="heading2">La tecnología más actualizada permite un acceso y un proceso fácil y rápido</h2>
      <p class="paragraph">Efisys Facturación utiliza tecnología de Google en la nube para almacenar la información y ejecutar los procesos. Usted puede ingresar o consultar facturas desde cualquier equipo con conexión a Internet.</p>
    </div>
  </div>
</div>
<div id="EasyMedEsSeguro" *ngIf="sitio=='EasyMed'" data-w-id="b4bc7c89-83d6-f7bf-102e-35f47881cd61" class="section-foto-2-easymed wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6"></div>
    <div class="w-col w-col-6">
      <h1 class="heading"><br>La seguridad de la información de los pacientes es vital<br>‍</h1>
      <p class="paragraph">Los médicos y los pacientes tienen una justificada preocupación por la privacidad de los datos clínicos. EasyMed utiliza las mejores herramientas y técnicas para evitar los riesgos.</p>
      <p class="paragraph"><br><br><br><br><br></p>
    </div>
  </div>
</div>
<div id="EfisysEsSeguro" *ngIf="sitio=='Efisys'" data-w-id="b4bc7c89-83d6-f7bf-102e-35f47881cd61" class="section-foto-2-efisys wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6"></div>
    <div class="w-col w-col-6">
      <h1 class="heading"><br>La seguridad de su información es vital!<br>‍</h1>
      <p class="paragraph">Todas las personas tienen una justificada preocupación por la privacidad de los datos que registran en Internet. Efisys utiliza las mejores herramientas y técnicas para evitar los riesgos.</p>
      <p class="paragraph"><br><br><br><br><br></p>
    </div>
  </div>
</div>
<div *ngIf="sitio=='EasyMed'" class="section-texto wf-section">
  <div class="columns-2 w-row">
    <div class="w-col w-col-6">
      <h2 class="heading2">EasyMed permite el acceso solo a las personas autorizadas y para la información autorizada</h2>
      <p class="paragraph">EasyMed emplea las técnicas más avanzadas para garantizar que solo las personas que el médico designe puedan consultar o ingresar datos, y solo en los temas que les sean permitidos.</p>
    </div>
    <div class="w-col w-col-6">
      <h2 class="heading2">Las mejores herramientas de la nube aseguran la confidencialidad de la información de los pacientes</h2>
      <p class="paragraph">Entre éstas constan: la seguridad de la base de datos de Google, identificación por usuario y contraseña, segundo factor de seguridad, reconocimiento de dispositivos autorizados y permisos de usuario.</p>
    </div>
  </div>
</div>
<div *ngIf="sitio=='Efisys'" class="section-texto wf-section">
  <div class="columns-2 w-row">
    <div class="w-col w-col-6">
      <h2 class="heading2">Efisys Facturación permite el acceso solo a las personas autorizadas y solo a la información autorizada</h2>
      <p class="paragraph">Efisys emplea las técnicas más avanzadas para garantizar que solo las personas que el administrador designe puedan consultar o ingresar datos, y solo en los temas que les sean permitidos.</p>
      <p class="paragraph"><br><br></p>
    </div>
    <div class="w-col w-col-6">
      <h2 class="heading2">Las mejores herramientas de la nube aseguran la confidencialidad de sus datos</h2>
      <p class="paragraph">Entre éstas constan: la seguridad de la base de datos de Google, identificación por usuario y contraseña, segundo factor de seguridad y permisos de usuario.</p>
    </div>
  </div>
</div>
<div id="UtilizarEasyMed" *ngIf="sitio=='EasyMed'" data-w-id="6b878c81-3996-60e6-6644-60433b93ea31" class="section-foto-3 wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6">
      <h1 class="heading"><br>Es momento de dar un salto adelante en la atención a sus pacientes<br>‍</h1>
      <p class="paragraph">Para utilizar EasyMed basta que se contacte con nosotros. <br><br>Somos Smarttec, creamos sistemas amigables y seguros y damos el mejor soporte técnico a nuestros usuarios. <br><br></p>
      <a href="contactosmarttec.html" class="button-copy w-button">Dé clic aquí para contactar con Smarttec</a>
      <p class="paragraph"><br><br><br></p>
    </div>
    <div class="w-col w-col-6"></div>
  </div>
</div>
<div id="UtilizarEfisys" *ngIf="sitio=='Efisys'" data-w-id="6b878c81-3996-60e6-6644-60433b93ea31" class="section-foto-3 wf-section">
  <div class="columns1 w-row">
    <div class="w-col w-col-6">
      <h1 class="heading"><br>Es momento de dar un salto adelante en la atención a sus clientes<br>‍</h1>
      <p class="paragraph">Para utilizar Efisys Facturación basta que se contacte con nosotros. <br><br>Somos Smarttec, creamos sistemas amigables y seguros y damos el mejor soporte técnico a nuestros usuarios. <br><br></p>
      <a href="contactosmarttec.html" class="button-copy w-button">Dé clic aquí para contactar con Smarttec</a>
      <p class="paragraph"><br><br><br></p>
    </div>
    <div class="w-col w-col-6"></div>
  </div>
</div>
<div class="section-texto wf-section">
  <h2 class="heading2">Esperamos conocerle pronto!</h2>
</div>
